import { instance } from "../../util/http";
import apis from "../../config/apis";

const getNewToken = ({ userId, testKey }) => {
  return instance.put(apis.Authentication.Login, {
    userId: userId,
    testKey: testKey,
  });
};

const getJsApiConfig = () => {
  return instance.get(apis.JsApiConfig);
};

const getUserInfo = () => {
  return instance.get("/profile");
};

const wxLogin = () => {
  var url =
    "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx7f53588fbd8d02fe&redirect_uri=http%3a%2f%2fservice.aggregator.taohualian168.net%2fapi%2fv1%2fWxRedirectPage&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
  return instance.get(url);
};

export default {
  getNewToken,
  getUserInfo,
  wxLogin,
  getJsApiConfig
};
